/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, March 28th 2022, 11:29:20 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSDialog, OSDialogProps } from "ui-widgets";
import DialogContent from "@mui/material/DialogContent";

export type ServiceBuilderSelectorDialogProps = Pick<OSDialogProps, "open" | "onClose" | "children" | "popUpTitle">;

export const ServiceBuilderSelectorDialog = (props: ServiceBuilderSelectorDialogProps) => {
  return (
    <OSDialog
      className="os-service-builder-modal"
      popUpTitle={props.popUpTitle}
      open={props.open}
      onClose={props.onClose}
    >
      <DialogContent>{props.children}</DialogContent>
    </OSDialog>
  );
};
